export default function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-util/Dom/contains.js
// module id = 149
// module chunks = 0